import { Field } from 'redux-form';
import React from 'react';

import { emptyRequiredFieldValidator } from '../validators';
import Autocomplete from '../../../../../Shared/Forms/Autocomplete';

const sortByLabel = (a, b) => a.label.toLowerCase().localeCompare(b.label.toLowerCase());
const sortOptions = options =>
  options.sort(sortByLabel).reduce((result, x) => {
    result[x.value] = x.label;
    return result;
  }, {});

const ListObjectField = ({ name, label, options, onChange, readonlyForm }) => (
  <Field
    name={name}
    component={Autocomplete}
    source={sortOptions(options)}
    label={label}
    direction="auto"
    suggestionMatch="anywhere"
    multiple={false}
    autoComplete="off"
    showSuggestionsWhenValueIsSet
    required
    disabled={readonlyForm || options.length < 2}
    onChange={(_, value) => onChange(value)}
    validate={() => emptyRequiredFieldValidator(options)}
  />
);

ListObjectField.displayName = 'ListObjectField';

export default ListObjectField;



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/ListObjectField.js